
/************************************************/
/* Variables                                    */
/************************************************/
var viewModel = new sm.portal.vm.InquiryViewModel();

/************************************************/
/* Page Object                                   */
/************************************************/
(function ($) {
    var sm = window.sm = window.sm || {};

    if (typeof sm.portal === "undefined") {
        $.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.page === "undefined") {
        $.extend(sm.portal, { page: {} });
    }
    if (typeof sm.portal.page.inquiry === "undefined") {
        $.extend(sm.portal.page, { inquiry: {} });
    }

    function initPage() {
        // Initialize the View Model
        viewModel = new sm.portal.vm.InquiryViewModel();

        $.when(
            sm.portal.utility.loadTemplate('InquiryTemplate', 'formTemplates'),
            sm.portal.utility.loadTemplate('ValidationFieldTemplate', 'validationTemplates'),
            sm.portal.utility.loadTemplate('MailingAddressTemplate', 'addressFormTemplates'),
            sm.portal.utility.loadTemplate('MailingAddressTemplateNew', 'addressFormTemplatesNew'),
            sm.portal.utility.loadTemplate('AccountTemplate', 'accountTemplates'),
            sm.portal.utility.loadTemplate('TermsAndConditionsTemplate', 'termsTemplates'),
            sm.portal.utility.loadTemplate('PortalValidationMessagesTemplate', 'portalValidationMessagesTemplates'),
            sm.portal.utility.loadTemplate('PortalWarningMessagesTemplate', 'portalWarningMessagesTemplates')
        ).done(function () {

            viewModel.TemplatesLoaded(true);
            viewModel.AccountViewModel().IsUserLoggedIn(function () {
                viewModel.LoadInitialData();
            });
        });

        // Bind to Page Elements
        ko.applyBindings(viewModel);
    }

    $.extend(true, sm.portal.page.inquiry, {
        initPage: initPage
    });

})(jQuery);

/************************************************/
/* Event Hooks                                    */
/************************************************/
(function ($) {

    $(document).bind('afterSMInitPage', function () {
        sm.portal.page.inquiry.initPage();
    });

})(jQuery);